import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UnpinnedIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Unpinned",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M3 29.28c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l7.67-7.67a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-7.67 7.67c-.22.22-.52.33-.81.33M28.14 29.28c-.29 0-.58-.11-.81-.33L2.19 3.81a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l25.14 25.14a1.14 1.14 0 0 1-.81 1.95M20.83 15.65c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l1.35-1.35c.29-.29.71-.4 1.1-.3 1.35.36 2.72.15 3.85-.54l-6.79-6.79c-.69 1.13-.9 2.5-.54 3.85.1.39 0 .81-.3 1.1l-1.35 1.35c-.45.45-1.17.45-1.62 0a1.14 1.14 0 0 1 0-1.62l.91-.91c-.38-2.29.35-4.65 1.99-6.29a1.15 1.15 0 0 1 1.62 0l8.59 8.59c.45.45.45 1.17 0 1.62a7.2 7.2 0 0 1-6.29 1.99l-.91.91c-.22.22-.52.33-.81.33Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M16 26.92c-.3 0-.59-.12-.81-.33L4.45 15.85a1.144 1.144 0 0 1 .01-1.62c.62-.62 1.33-1.14 2.1-1.55a1.14 1.14 0 1 1 1.06 2.02c-.23.12-.46.26-.67.41l8.98 8.98c.15-.22.29-.44.41-.67.29-.56.99-.77 1.54-.48.56.29.77.99.48 1.54-.41.77-.93 1.48-1.55 2.1-.21.21-.5.33-.81.33Z"
    })]
  }));
};